// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Document\\ View-iframe-BlIsc {\n  left: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/globals/document/Document View.less","webpack://./src/globals/document/Document%20View.less"],"names":[],"mappings":"AACA;EACI,OAAA;ACAJ","sourcesContent":["@environment_type_id: 1;\n.iframe{\n    left:0;\n}",".iframe {\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe": "Document View-iframe-BlIsc"
};
export default ___CSS_LOADER_EXPORT___;
